import Phaser from "phaser";
import GameflowHelper from "../Helpers/GameflowHelper";
import Scene2VM from "../ViewModels/Scene2ViewModels";
import store from "../../store/store.jsx";
import { gameVM } from "../Game.jsx";
import Loading from "./Loading";
import { dispatchChangeScene, dispatchChangeProgress } from "../reducers/sceneReducer";
import emitter from "../Events/EventManager";
import { NEXT_PROGRESS } from "../Events/Events";

export default class Scene2 extends Phaser.Scene {
  Scene2VM;
  progress;
  constructor() {
    super({ key: "Scene2" });
    this.Scene2VM = new Scene2VM(this);
    this.Loading = new Loading(this);
  }

  preload() {
    this.Scene2VM.preloadAssets();
    this.Loading.progressBar();
    dispatchChangeScene("Scene2");
  }

  async create() {
    //add instruction 0
    this.Scene2VM.addBackground();
    await GameflowHelper.action(() => {}, 1000);
    this.Scene2VM.addBackgroundHover("#000000", 0.5);

    this.sound.add("clickSound");
    this.sound.add("incorrectSound");
    this.sound.add("correctSound");
    this.sound.add("finishSound");

    await this.addInstruction("wordsInAdvance", "gameBackground");
    await this.addInstruction("gameInfo", "howToPlay");
    await this.addInstruction("playInfo", "keyPoint");
    await this.addInstruction("keypoint1", "next");
    await this.addInstruction("keypoint2", "startGame");
  }

  update() {}

  addInstruction(centeredImageKey, buttonImageKey) {
    return new Promise((resolve, reject) => {
      if (centeredImageKey == "wordsInAdvance") dispatchChangeProgress(0);
      if (centeredImageKey == "gameInfo") dispatchChangeProgress(1);
      if (centeredImageKey == "playInfo") dispatchChangeProgress(2);
      if (centeredImageKey == "keypoint1") dispatchChangeProgress(3);
      if (centeredImageKey == "keypoint2") dispatchChangeProgress(4);

      this.centeredImage = this.add.image(1920 / 2, 0.43 * 1080, centeredImageKey);
      this.Scene2VM.fadeIn(centeredImageKey, 1, 150);

      this.goNextButton = this.add
        .image(1920 / 2, 0.825 * 1080, buttonImageKey)
        .setInteractive({ cursor: "pointer" });

      emitter.on(NEXT_PROGRESS, () => {
        this.goNextButton.emit("pointerup");
      });

      this.goNextButton.on("pointerup", async () => {
        emitter.removeListener(NEXT_PROGRESS);

        this.sound.play("clickSound");
        this.goNextButton.destroy();
        this.centeredImage.destroy();

        if (buttonImageKey == "startGame") {
          await GameflowHelper.action(() => {}, 600);
          this.scene.start("Scene3");
        }

        resolve(true);
      });
    });
  }
}
